<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      resizable
      border
      size="small"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:currencyAmount="{ row }">
        <span>{{ row.currencyAmount }} {{ row.currencyUnit }}</span>
      </template>
        <template v-slot:receiveStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.receiveStatus == 'Y' ? 'success' : 'danger'"
        >
          {{ row.v_receiveStatus }}
        </el-tag>
      </template>
      <template v-slot:billStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.v_billStatus === '已审核'
              ? 'primary':'danger'
          "
        >
          {{ row.v_billStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <Detail :visible.sync="visible" @close="close" :finPaymentNoInvoice="finPaymentNoInvoice"></Detail>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import Detail from '../../detail'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { Detail },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      visible: false,
      finPaymentNoInvoice: '',
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'detail':
          this.detail(data)
          break
        case 'message':
          this.message(data)
          break
        case 'check':
          this.check(data)
          break
      }
    },
    detail(data) {
      this.visible = true
      this.finPaymentNoInvoice = data.finPaymentNoInvoice
      console.log(data)
    },
    close() {
      this.finPaymentNoInvoice = ''
      this.visible = false
    },
    message({ finPaymentNoInvoice }) {
      this.$confirm(
        this.$l('tips_email_message') || '是否要发送邮件通知？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .finPaymentNoInvoiceNotifyEmailApi({ finPaymentNoInvoice })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('tips_send_ok') || '发送成功！',
              type: 'success',
            })
            this.$emit('reload')
            this.loadingClose()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    check({ finPaymentNoInvoice }) {
      this.$confirm(
        this.$l('tips_approved') || '是否要进行收到发票操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .finPaymentNoInvoiceReceivedApi({ finPaymentNoInvoice })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('tips_received_ok') || '更新成功',
              type: 'success',
            })
            this.$emit('reload')
            this.loadingClose()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
